import { ModalId } from '@heidi/schema/ml-scribe';

export const SIDE_NAV_CREDIT_USAGE_POPOVER_MODAL_ID =
  ModalId.T3_CUSTOM_AUDIENCE_CLINICIAN_MAX_CREDIT_USAGE_POPOVER;
